// import { Button } from "react-bootstrap";
import { ContentLogoCard } from "../Uploader/ContentLogoCard";
import { EmptyAddAttachmentCard } from "../Uploader/EmptyAddAttachmentCard";
// import { EmptyLogoCard } from "../../Uploader/EmptyLogoCard";
import React from "react";
// import DropzoneS3Uploader from "react-dropzone-s3-uploader";
// import Card from "../../Card/Card";
import S3Uploader from "../Uploader/DropzoneUploader";

// const ExpenseFormAttachmentUploader = ({ companyId }) => {
//   const uploadOptions = {
//     server: process.env.REACT_APP_GRAPHQL_ENDPOINT,
//     signingUrlQueryParams: { uploadType: "avatar" },
//     s3path: `documents/${companyId}/expenses/`
//     // s3path: "tmp/"
//   };
//   const s3Url = "https://s3-eu-west-1.amazonaws.com/netwips/";
//   const id = this.props.id;
//
//   const src = s3Url + this.props.filename;
//   console.log("S3Uploader render", this.props, src);
//
//   return(
//     <DropzoneS3Uploader
//       onFinish={values => this.handleFinishedUpload({ ...values, id })}
//       s3Url={s3Url}
//       maxSize={1024 * 1024 * 5}
//       upload={uploadOptions}>
//       <div  style={{
//           height: 'calc(100vh - 90px)',
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: 'center',
//           alignItems: "center"
//         }}>
//         <Button bsStyle="info">
//           <i className="fa fa-2x fa-file" />
//         </Button>
//         <br/>
//         <hr/>
//         <br/>
//         <Button block>
//           <i className="fa fa-2x fa-plus-circle" />
//         </Button>
//       </div>
//     </DropzoneS3Uploader>
//   )
// }

const AttachmentUploader = ({
  // companyId,
  attachment,
  onUpdateAttachment,
  onCreateAttachment,
  path,
  disabled,
  forceFileName,
  sendNotification
}) => {
  const s3Path = path; //`documents/${companyId}/expense/`;

  return (
    <div
      style={
        {
          // width: "400px"
          // height: "calc(100vh - 90px)",
          // display: "flex",
          // flexDirection: "column",
          // justifyContent: "center",
          // alignItems: "center"
        }
      }>
      {attachment && (
        <S3Uploader
          accept={"image/jpeg, image/png, application/pdf"}
          forceFileName={forceFileName}
          EmptyComponent={EmptyAddAttachmentCard}
          ContentComponent={ContentLogoCard}
          id={attachment.id}
          filename={attachment.path}
          s3path={s3Path}
          onFinish={onUpdateAttachment}
          sendNotification={sendNotification}
        />
      )}
      {!attachment && (
        <S3Uploader
          accept={"image/jpeg, image/png, application/pdf"}
          forceFileName={forceFileName}
          disabled={disabled || false}
          EmptyComponent={EmptyAddAttachmentCard}
          ContentComponent={ContentLogoCard}
          s3path={s3Path}
          onFinish={values => onCreateAttachment(values)}
          sendNotification={sendNotification}
        />
      )}
      {/* <Button bsStyle="info">
        <i className="fa fa-2x fa-file" />
      </Button>
      <br />
      <hr />
      <br />
      <Button block>
        <i className="fa fa-2x fa-plus-circle" />
      </Button> */}
    </div>
  );
};

export default AttachmentUploader;
